// Optimized image preloader utility with priority-based loading

// Critical images that must load immediately on login
const CRITICAL_IMAGES = [
  require('../assets/lifepsensor-logo-text.png'),
  require('../assets/lifepsensor-logo-text-small.png'),
  require('../assets/user.png'),
];

// Page-specific image sets
const PAGE_IMAGES = {
  dashboard: [
    require('../assets/wellness.png'),
    require('../assets/chat.png'),
    require('../assets/book.png'),
  ],
  wellness: [
    require('../assets/BloodTest.png'),
    require('../assets/profile-section-Image.png'),
  ],
  chat: [
    require('../assets/chat.png'),
  ],
  learn: [
    require('../assets/book.png'),
  ],
  insights: [
    require('../assets/video.png'),
  ],
  consultations: [
    require('../assets/video.png'),
  ],
  profile: [
    require('../assets/profile-section-Image.png'),
  ],
};

// Non-critical images that can be loaded in background
const BACKGROUND_IMAGES = [
  require('../assets/Google-icon.png'),
  require('../assets/Login-Background.png'),
  require('../assets/Login-Background-2.png'),
  require('../assets/Login-Background-3.png'),
  require('../assets/Login-Background-4.png'),
  require('../assets/philippines.png'),
  require('../assets/us.png'),
];

const IMAGE_CACHE_KEY = 'lifepsensor_images_preloaded';

/**
 * Preload critical images only (fast login)
 */
export const preloadCriticalImages = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    let loadedCount = 0;
    let errorCount = 0;
    const totalImages = CRITICAL_IMAGES.length;

    if (totalImages === 0) {
      resolve();
      return;
    }


    const checkComplete = () => {
      if (loadedCount + errorCount === totalImages) {
        if (errorCount > 0) {

        }
        resolve();
      }
    };

    CRITICAL_IMAGES.forEach((imagePath) => {
      const img = new Image();
      
      img.onload = () => {
        loadedCount++;
        checkComplete();
      };

      img.onerror = () => {
        errorCount++;

        checkComplete();
      };

      img.src = imagePath;
    });
  });
};

/**
 * Preload images for a specific page
 */
export const preloadPageImages = (pageName: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const images = PAGE_IMAGES[pageName as keyof typeof PAGE_IMAGES] || [];
    
    if (images.length === 0) {
      resolve();
      return;
    }


    let loadedCount = 0;
    let errorCount = 0;

    const checkComplete = () => {
      if (loadedCount + errorCount === images.length) {
        if (errorCount > 0) {

        }
        resolve();
      }
    };

    images.forEach((imagePath) => {
      const img = new Image();
      
      img.onload = () => {
        loadedCount++;
        checkComplete();
      };

      img.onerror = () => {
        errorCount++;

        checkComplete();
      };

      img.src = imagePath;
    });
  });
};

/**
 * Preload background images (non-blocking)
 */
export const preloadBackgroundImages = (): void => {

  // Use requestIdleCallback for non-blocking loading
  const loadInBackground = () => {
    BACKGROUND_IMAGES.forEach((imagePath) => {
      const img = new Image();
      img.src = imagePath;
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadInBackground);
  } else {
    setTimeout(loadInBackground, 100);
  }
};

/**
 * Legacy function - now just preloads critical images
 * @deprecated Use preloadCriticalImages() instead
 */
export const preloadImages = (): Promise<void> => {
  return preloadCriticalImages();
};

/**
 * Clear image preload flag on logout
 */
export const clearImageCache = () => {
  sessionStorage.removeItem(IMAGE_CACHE_KEY);
};

/**
 * Check if images have been preloaded
 */
export const areImagesPreloaded = (): boolean => {
  return sessionStorage.getItem(IMAGE_CACHE_KEY) === 'true';
};


